export const COLORS = {
  danger: '#F64E60',
  initial: '#353535',
  primary: '#04a777',
};
